var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetAllocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9243",
    "data-name": "Group 9243",
    transform: "translate(-14259 -9096)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1803",
    "data-name": "Ellipse 1803",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(14259 9096)",
    fill: "#d34a7c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    transform: "translate(14272 9108.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10442",
    "data-name": "Path 10442",
    d: "M25.5,6.482H5.04a.962.962,0,0,0-.93.991V22.336H26.427V7.473A.962.962,0,0,0,25.5,6.482ZM5.04,4.5A2.886,2.886,0,0,0,2.25,7.473V24.318H28.286V7.473A2.886,2.886,0,0,0,25.5,4.5Z",
    transform: "translate(-0.268)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10443",
    "data-name": "Path 10443",
    d: "M0,27H30v.991a2.9,2.9,0,0,1-2.812,2.973H2.813A2.9,2.9,0,0,1,0,27.991Z",
    transform: "translate(0 -3.964)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetAllocation);
export default __webpack_public_path__ + "static/media/asset-allocation.f95ca6cc9e252ad05e417719d8bd1b13.svg";
export { ForwardRef as ReactComponent };